/**
 * Allows sorting by a key function rather than a comparison function.
 * @param keyFunc
 */
export const sortByKeyFunc = (keyFunc) => (a, b) => {
  if (keyFunc(a) < keyFunc(b)) return -1;
  else if (keyFunc(a) > keyFunc(b)) return 1;
  else return 0;
};

/**
 * Sorts the provided array using the provided key function.
 * @param arr
 * @param func
 */
export const sortBy = (arr, func) => [...arr].sort(sortByKeyFunc(func));



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/sort.js